<template>
    <v-layout row class="mx-0 ">
        <v-flex xs12>

            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">Visa Year</th>
                        <th class="text-left">Visa type</th>
                        <th class="text-left">Countable Stay Days</th>
                        <th class="text-left">Uncountable Stay Days</th>
                        <th class="text-left">Total Stay Days</th>
                        <th class="text-left">Created At</th>
                        <th class="text-left">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(log, index) in logs" :key="log.id">
                        <td>{{ log.visa_year }}</td>
                        <td>{{ log.type }}</td>
                        <td>{{ log.countable_days_stayed }}</td>
                        <td>{{ log.uncountable_days_stayed }}</td>
                        <td>{{ log.uncountable_days_stayed + log.countable_days_stayed }}</td>
                        <td>{{ formatedDate(log.created_at) }}</td>
                        <td>
	                        <v-chip small class="ma-2" :color="log.deleted_at ? 'red' : 'green'" text-color="white">
		                        {{ log.deleted_at ? 'Deleted' : 'Active'}}
	                        </v-chip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn dark fab x-small class="mr-2" color="blue darken-3" @click="updatePreviousStay" v-on="on"
                                     v-if="$oauth.checkIfHasPermission(['refresh previous-stay']) && index === 0 && !checkIfToday(log.created_at)">
                                <v-icon dark>mdi mdi-refresh</v-icon>
                              </v-btn>
                            </template>
                            <span>Refresh Previous Stay</span>
                          </v-tooltip>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-flex>
    </v-layout>
</template>

<script>
import {API_URL, VERSION, VERSIONED_API_URL} from "../../config/config.js";
    import Http from "axios";
    import moment from "moment";

    export default {
        name: "YearLog",
        props: ['travellerId'],
        data() {
            return {
                logs: []
            }
        },
        methods:{
          formatedDate: function (date){
            return moment(date).format('YYYY-MM-DD');
          },

          checkIfToday: function (date){
            return moment(date).isSame(new Date(), "day");
          },

          fetchYearLogs(){
            Http.get(API_URL + VERSION + '/travellers-histories/year-log/' + this.travellerId).then((res) => {
              this.logs = res.data;
            })
          },

          async updatePreviousStay(track) {
            await this.$dialog.confirm({
              text: "Are you sure to update previous stay?",
              title: "Warning",
              actions: {
                false: "No",
                true: {
                  color: "red",
                  text: "Yes",
                  handle: () => {
                    Http.post(`${VERSIONED_API_URL}/previous-stay-report/${this.travellerId}/auto-update`)
                        .then((res) => {
                          this.$store.commit('Notification/showSuccess', "Previous Stay Updated Successfully");
                          this.fetchYearLogs();
                        })
                        .catch(error => {
                          console.error(error);
                          this.$store.commit('Notification/showError', "Something went wrong");
                        });
                  }
                }
              }
            });
          },
        },
        mounted() {
          this.fetchYearLogs()
        }
    }
</script>
